// Angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// Environment
import { environment } from '@env/environment';
// Rxjs
import { Observable } from 'rxjs';
// Models
import {
  IOrderDetailResponse,
  IShoppingCartResponse,
} from '@core/models-v2/cart/order-details.interface';
import { IShoppingCart } from '@core/models-v2/cart/shopping-cart.interface';

const API_CART = `${environment.apiEcommerce}/api/v1/shopping-cart`;

@Injectable({
  providedIn: 'root',
})
export class SalesOrderApiService {
  private http = inject(HttpClient);

  getOrderDetails(params: {
    user: string;
    salesDocumentType?: number;
    search?: string;
    statuses?: string[];
    page?: number;
    limit?: number;
    sort?: string;
  }): Observable<IOrderDetailResponse> {
    return this.http.get<IOrderDetailResponse>(`${API_CART}/order-details`, {
      params,
    });
  }

  /**
   * Obtener ordenes de venta (OVs).
   * @param params
   * @returns
   */
  getMany(params: {
    search?: string;
    page?: number;
    limit?: number;
    sort?: string;
  }): Observable<IShoppingCartResponse> {
    return this.http.get<IShoppingCartResponse>(
      `${API_CART}/all-order-details`,
      { params }
    );
  }

  /**
   * Confirmar orden de venta (OV).
   * @param salesId - Id de la orden de venta
   * @returns
   */
  confirm(salesId?: string): Observable<IShoppingCart> {
    return this.http.post<IShoppingCart>(`${API_CART}/confirm-document`, {
      salesId,
    });
  }
}
